import { SIGNUP_CODE } from "../lib/constants/actions";

export const getCodes = (data) => ({ type: SIGNUP_CODE.GET_SIGNUP_CODES, payload: data });
export const getCodesSuccess = (data) => ({ type: SIGNUP_CODE.GET_SIGNUP_CODES_SUCCESS, payload: data });


export const saveCode = (data) => ({ type: SIGNUP_CODE.SAVE_SIGNUP_CODE, payload: data });
export const saveCodeSuccess = (data) => ({ type: SIGNUP_CODE.SAVE_SIGNUP_CODE_SUCCESS, payload: data });


export const deleteCode = (data) => ({ type: SIGNUP_CODE.DELETE_SIGNUP_CODE, payload: data });
export const deleteCodeSuccess = (data) => ({ type: SIGNUP_CODE.DELETE_SIGNUP_CODE_SUCCESS, payload: data });











